<ep-sub-panel [form]="form" panelType="transparent" [collapseTitleArea]="!firstRow">
  <form [formGroup]="form">
    <ep-field-block>
      <ep-field-section>
        <ep-field-group>
          <ep-field
            *ngIf="!(getControlValue('Filing.DocLink_ID') > 0)"
            columnSpan="23px"
            [collapseLabelArea]="!firstRow"
            hideLabel="false"
            label="Select"
            format="checkbox-YN"
            controlPath="Filing.Selected_Ind"
          ></ep-field>
          <ep-field
            *ngIf="getControlValue('Filing.DocLink_ID') > 0"
            columnSpan="20px"
            [collapseLabelArea]="!firstRow"
            hideLabel="false"
            label="Existing Filing"
            format="spacer"
          ></ep-field>
          <ep-field
            label="Filing Reference"
            format="container"
            columnSpan="3"
            [collapseLabelArea]="!firstRow"
            [tooltip]="getFilingTooltip()"
          >
            <div>
              <div class="ep-truncate" style="height: var(--height-input)">
                <i *ngIf="isFontAwesomeIcon(getRoleIcon())" [class]="'me-2 fa fa-fw ' + getRoleIcon()"></i>
                <aurora-icon *ngIf="!isFontAwesomeIcon(getRoleIcon())" class="me-2" [icon]="getRoleIcon()"></aurora-icon>
                <span>{{ getControlValue('Filing.Entity.Entity_Name') }}</span>
                <span *ngIf="getControlValue('Filing.Contract.Contract_ID') > 0" style="margin-left: 8px">
                  <aurora-icon icon="contract" class="me-1"></aurora-icon>
                  {{ getControlValue('Filing.Contract.Contract_Num') }}</span
                >
                <span *ngIf="getControlValue('Filing.Claim.Claim_ID') > 0" style="margin-left: 8px">
                  <aurora-icon icon="claim" class="me-1"></aurora-icon>
                  {{ getControlValue('Filing.Claim.Book_Claim_Num') }}</span
                >
              </div>
            </div>
          </ep-field>
        </ep-field-group>
        <ep-field-group>
          <ep-field
            label="File Drawer"
            [collapseLabelArea]="!firstRow"
            format="dropdownSelector-filedrawer"
            controlPath="Filing.File_Drawer"
          ></ep-field>
          <ep-field
            label="File Folder"
            [collapseLabelArea]="!firstRow"
            format="dropdownSelector-filefolder"
            controlPath="Filing.File_Folder"
          ></ep-field>
          <ep-field
            columnSpan="60px"
            label="Public"
            [collapseLabelArea]="!firstRow"
            format="checkbox-YN"
            controlPath="Filing.Public_Document_Ind"
          ></ep-field>
        </ep-field-group>
      </ep-field-section>
    </ep-field-block>
  </form>
</ep-sub-panel>
